module.exports = __webpack_public_path__ + "static/media/returns.81ac02bc.svg";